import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Tabs } from "antd";
import { setSection } from "../../../redux/ducks/Section";
import { useParams } from "react-router-dom";
import PreventiveForm from "./ProjectEstimateTabs/PreventiveForm";
import Team from "./ProjectEstimateTabs/Team";
import CostEstimation from "./ProjectEstimateTabs/CostEstimation";
import KickOff from "./ProjectEstimateTabs/KickOff";
import Rap from "./ProjectEstimateTabs/Rap";
import { checkRoles } from "../../../utils/utilities";
import { projectEstimateTabs } from "../../../utils/properties";
import { get } from "lodash";
import { resetForm } from "../../../redux/ducks/EditableTable";
import { resetState } from "../../../redux/ducks/ProjectEstimate";

const ProjectEstimateDetails = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const params = useParams();

  useEffect(() => {
    dispatch(
      setSection({
        section: {
          title: params.id,
        },
      })
    );
  }, []);

  const userInfo = useSelector((state) => get(state.userInfoDuck, "userInfo", {}));
  const mappingKey = {
    PreventiveForm: <PreventiveForm />,
    Team: <Team />,
    CostEstimation: <CostEstimation id={params.id} />,
    KickOff: <KickOff id={params.id} />,
    Rap: <Rap id={params.id} />,
  };

  const resetAllDataOnChangeTab = () => {
    dispatch(resetForm());
    dispatch(resetState());
  };
  const projectEstimateTabsFiltered = [];
  Object.keys(projectEstimateTabs).forEach((p) => {
    if (checkRoles(userInfo.roles, projectEstimateTabs[p].view)) {
      projectEstimateTabsFiltered.push({
        label: t(`projectEstimate.detail.${p}`),
        key: p,
        children: mappingKey[projectEstimateTabs[p].component],
      });
    }
  });
  return (
    <Tabs
      className="PFtabs"
      defaultActiveKey={0}
      onChange={() => resetAllDataOnChangeTab()}
      items={projectEstimateTabsFiltered}
    />
  );
};

export default ProjectEstimateDetails;
